<div class="sticker-group" [ngClass]="size ? 'sticker-group--' + size : null" *ngIf="showStickers">
  <ng-container *ngIf="showDonate">
    <ng-container *ngTemplateOutlet="donateSticker"></ng-container>
  </ng-container>

  <ng-container *ngIf="unavailable || (product && !isAvailable)">
    <ng-container *ngTemplateOutlet="notAvailable"></ng-container>
  </ng-container>

  <ng-container *ngIf="!showDonate && !unavailable && (points !== undefined || (product && isAvailable))">
    <div class="sticker sticker--miles" [ngClass]="size ? 'sticker--' + size : null" *ngIf="!discountOnly && pointsString">
      <span class="sticker__top-label" *ngIf="showTopLabel">{{ "general.label.from" | translate }}</span>
      <span class="sticker__counter">{{ pointsString }}</span>
      <span class="sticker__label">{{ "general.label.air_miles" | translate }}</span>
    </div>
    <div class="sticker sticker--discount-only" *ngIf="discountOnly && discount">
      <span class="sticker__counter">{{ discount | currency }}</span>
      <span class="sticker__label">{{ "general.label.discount" | translate }}</span>
    </div>
    <ng-container *ngIf="productCost as cost">
      <div class="sticker sticker--euro" [ngClass]="size ? 'sticker--euro--' + size : null" *ngIf="cost.price">
        <span class="sticker__counter">+{{ cost.price | currency }}</span>
      </div>
      <div
        class="sticker sticker--discount"
        [ngClass]="size ? 'sticker--discount--' + size : null"
        *ngIf="discount && !cost.price && !discountOnly"
      >
        <span class="sticker__counter">{{ discount | currency }}</span>
        <span class="sticker__label">{{ "general.label.discount" | translate }}</span>
      </div>
      <div class="sticker sticker--miles-only" [ngClass]="size ? 'sticker--miles-only--' + size : null" *ngIf="!cost.price && !discount">
        <span class="sticker__label">{{ "general.label.miles_only" | translate }}</span>
      </div>
    </ng-container>
  </ng-container>
</div>

<ng-template #donateSticker>
  <div class="sticker sticker--donate" [ngClass]="size ? 'sticker--donate--' + size : null">
    <span class="sticker__label">{{ "general.label.donate" | translate }}</span>
  </div>
</ng-template>

<ng-template #notAvailable>
  <div class="sticker sticker--not-available" [ngClass]="size ? 'sticker--not-available--' + size : null">
    <span class="sticker__label">{{ "general.label.temporarily_unavailable" | translate }}</span>
  </div>
</ng-template>
